import { languageToUrl } from './languageUtils';

// We are adding these here instead of on public-app because we are using these in pricing-pages-ui-components/static-1.16675/js/layouts/BaseLayout.tsx
// once BaseLayout.tsx is moved over to public-app we can move this file as well.
const PUBLIC_SITE_DOMAINS = {
  en: 'https://www.hubspot.com',
  de: 'https://www.hubspot.de',
  es: 'https://www.hubspot.es',
  pt: 'https://br.hubspot.com',
  fr: 'https://www.hubspot.fr',
  ja: 'https://www.hubspot.jp'
};
export const getPublicSiteDomain = () => languageToUrl(PUBLIC_SITE_DOMAINS);

/*
 * HSOC links its feature-table "Product & Services Catalog" affordance to the
 * Nordics customer pricing page. Relocated here from the deprecated
 * pricing-pages-lib so the shared HSOC feature-table containers (in-app +
 * public) can build the catalog href without importing the banned lib.
 */
export const getNordicsCustomerPricingUrl = () => `${getPublicSiteDomain()}/nordic-customer-pricing`;